// extracted by mini-css-extract-plugin
module.exports = {"host":"App_host__2Ho3X","language":"App_language__2Krmr"};